export default {
  BusinessBatchInventoryQuery: {
      header: {
        spuCode: 'Product Code',
        spuName: 'Product Name',
        warehouseCode: 'Warehouse Code',
        warehouseId: 'Warehouse Name',
        skuCode: 'SKU',
        categoryIdList: 'Product Category',
        warehouseTypeCode: 'Warehouse Type',
        exceedZero: 'Stock Availability >0'
      },
  
      table: {
        spuCode: 'Product Code',
        spuName: 'Product Name',
        skuCode: 'SKU',
        warehouseCode: 'Warehouse Code',
        warehouseName: 'Warehouse Name',
        expirationDate:"expiration Date",
        ShipmentSKUCode:"Shipment SKU Code",
        usableNum: 'Available Inventory',
        stockNum: 'In-stock Inventory',
        lockNum: 'Locked Inventory',
        wayNum: 'In-transit Inventory',
        preemptionNum: 'Preoccupied Inventory',
        waitNum: 'Awaiting Receipt Inventory',
        reservedNum: 'Reserved Inventory',
        typeCode: 'Warehouse Type',
        categoryName: 'Product Category',
        brandName: 'Brand Name',
        usableNum2: 'Available ',
        stockNum2: 'In Stock',
        lockNum2: 'Committed',
        changeNum: 'Transaction',
        pallet: 'Pallet Type',
        exportFileName: 'Inventory List'
      }
    }
  };
  